import { ResponseType } from "../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
const { clinicId } = getConstants()
const {DashboardApi}=api

export const getDashboarDetails = async (clinicid:number | null | undefined):Promise<ResponseType<any>>=>{
    const result = (
      await instance.get(`${DashboardApi.getDashboardData}${clinicid ? clinicid : clinicId}`)
    )
    return result.data
}